import loadable from '@loadable/component';
import { HubHomePage } from '../../../../../types';
import { useRootSelector } from '../../../../../store/hooks';
import { selectBrandHubPage } from '../../store/features/page';
import { selectBrandHubOptions } from '../../store/features/options';
import PageLayout from '../../layouts/PageLayout';
import { MetaTags } from '../../../shared/MetaTags';
import { HubModuleBuilder } from '../../../shared/siteBuilder/HubModuleBuilder';
import ErrorBoundary from '../../../../common/ErrorBoundary';
import { InformaMetaTagPageType } from '../../../../../constants';

const HubHeroModule = loadable(
  () =>
    import(
      /* webpackChunkName: "HubHeroModule" */ '../../../shared/siteBuilder/modules/HeroModule'
    ),
);
const FloatingEmailOptInModule = loadable(
  () =>
    import(
      /* webpackChunkName: "FloatingEmailOptInModule" */ '../../../shared/FloatingEmailOptInModule'
    ),
);

export function Home() {
  const {
    data: {
      home: {
        modules,
        details: { title, metaDescription },
      },
      header: {
        heroBanner: { inlineLogo, ...heroBanner },
        headerNavBar: { brandLogo },
      },
    },
  } = useRootSelector(selectBrandHubPage<HubHomePage>());
  const { data: options } = useRootSelector(selectBrandHubOptions);
  const { name: hubName, newsletterSignUp, promotionalSignUp } = options;

  const heading = title || 'Home';
  const emailOptInEnabled =
    newsletterSignUp.homeEnabled || promotionalSignUp.homeEnabled;

  return (
    <PageLayout>
      <MetaTags
        informaPageType={InformaMetaTagPageType.BasePage}
        informaPageId="home"
        thumbnail={brandLogo?.path}
        description={metaDescription}
        titleSuffix={hubName}
        title={heading}
      />
      {emailOptInEnabled && (
        <ErrorBoundary>
          <FloatingEmailOptInModule
            hubOptions={options}
            permissionTextName={hubName}
            pageType="home"
          />
        </ErrorBoundary>
      )}
      <HubHeroModule home module={heroBanner} />
      {modules.map((module, index) => (
        <ErrorBoundary key={index}>
          <HubModuleBuilder home module={module} />
        </ErrorBoundary>
      ))}
    </PageLayout>
  );
}
